export enum Endpoints {
  models_post = "/api/v1/models",
  exercises_get_id = "/api/v1/studentui/exercises/",
  exercises_post = "/api/v1/authorui/submissions/",
  exercises_post_id = "/authorui/exercises",
  submissionexercises_get_assessments = "/api/v1/studentui/submissionexercises/",
  // Same payload as the line above, but without the release filter: the student endpoint only
  // hands out an assessment once it has been published, which is exactly what teachers do last.
  submissionexercises_get_assessments_author = "/api/v1/authorui/submissionexercises/",
}
